export enum WebsiteNameId {
  ID = 'id',
  URL = 'url',
  CREATED_AT = 'createdAt',
}
